/** `GET /auth/invitations/{token}` (contracts/panel-api.md §2.6): lo que ve quien abre el enlace, sin sesión. */
import { z } from "zod";
import { BRAND_HEX, ownApiPath } from "@/api/schemas";

export const invitationPreviewSchema = z.object({
  client: z.object({
    name: z.string().min(1),
    accent_color: z.string().nullish().transform((value) => (value && BRAND_HEX.test(value) ? value : null)),
    logo_url: z.string().nullish().transform((value) => ownApiPath(value)),
  }),
  email_hint: z.string(),
  expires_at: z.string(),
});
export type InvitationPreview = z.infer<typeof invitationPreviewSchema>;

/** 43 caracteres base64url en el contrato; se acepta un rango por si cambia la longitud. */
export const INVITATION_TOKEN = /^[A-Za-z0-9_-]{16,128}$/;
